// extracted by mini-css-extract-plugin
module.exports = {"stepperPrecise":"style_stepperPrecise__3ebv5","stepperPrecise_currentValue":"style_stepperPrecise_currentValue__1xhkd"};